module.exports = __webpack_public_path__ + "static/img/zwsj@2x.650af48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zwsj@2x.png
// module id = A3+r
// module chunks = 2